import { Avatar, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import Text from "../Text/Text";
import dayjs from "dayjs";
import icon from "../../resource/icon";
import { MAP_QUOTA_TYPE } from "../../definitions/QuotaType";
import color from "../../resource/color";
import TablePagination from "./TablePagination";
import { FlexCol, FlexRow } from "../Container/Container";
import { image } from "../../resource";

interface Product {
  productId: number;
  productName: string;
  productImage?: string | null;
  productFreebiesImage?: string | null;
  commonName?: string;
  productGroup?: string;
  productStrategy?: string;
  productCodeNav?: string;
  packSize?: string;
}

interface Customer {
  customerCompanyId: number;
  customerName: string;
  customerNo: string;
  customerZone: string;
  customerGroup: string;
  products: Product[];
}

interface QuotaData {
  quotaId: string;
  quotaName: string;
  quotaType: string;
  startDate?: string | null;
  endDate?: string | null;
  customers: Customer[];
}

interface Props {
  data: QuotaData | null;
}

const datePattern = "DD/MM/YYYY";

function RenderContent({ data }: Props) {
  const [quota, setQuota] = useState<QuotaData | null>(null);

  useEffect(() => {
    setQuota(data);
  }, [data]);

  const columns: any = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 10,
      render: (_: any, record: Customer, index: number) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text fontWeight={600}>{index + 1}</Text>
        </div>
      ),
    },
    {
      title: "ชื่อร้าน",
      dataIndex: "customerName",
      key: "customerName",
      width: 200,
      render: (_: any, record: Customer) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text fontWeight={600}>{record.customerName}</Text>
          <Text level={6} color='Text3'>
            {record.customerNo} &nbsp;•&nbsp; {record.customerZone} &nbsp;•&nbsp;{" "}
            {record.customerGroup}
          </Text>
        </div>
      ),
    },
    {
      title: "สินค้า",
      key: "products",
      width: 340,
      render: (_: any, record: Customer) => (
        <div>
          {record.products.map((product, idx) => (
            <FlexRow
              key={product.productId || idx}
              align='center'
              style={{
                marginBottom: 12,
                borderBottom: idx !== record.products.length - 1 ? "0.3px solid #ddd" : "none",
              }}
            >
              <Avatar
                src={
                  !product.productImage || product.productImage === "No"
                    ? image.product_no_image
                    : product.productImage || product.productFreebiesImage
                }
                size={50}
                shape='square'
                onError={() => false}
                style={{ marginRight: 16 }}
              />
              <FlexCol>
                <Text level={5} fontWeight={600}>
                  {product.productName}
                </Text>
                {product.commonName && (
                  <Text level={6} color='background4'>
                    {product.commonName}
                  </Text>
                )}
                <Text level={6} color='background4'>
                  Product Group: {product.productGroup ?? "-"}
                </Text>
                {product.productStrategy && (
                  <Text level={6} color='background4'>
                    Strategy Group: {product.productStrategy}
                  </Text>
                )}
                {product.productCodeNav && (
                  <Text level={6} color='background4'>
                    Code Nav: {product.productCodeNav}
                  </Text>
                )}
                {product.packSize && (
                  <Text level={6} color='background4'>
                    Pack Size: {product.packSize}
                  </Text>
                )}
              </FlexCol>
            </FlexRow>
          ))}
        </div>
      ),
    },
  ];

  if (!quota) {
    return <Text>Loading...</Text>;
  }

  return (
    <div>
      <Row
        justify='space-between'
        style={{
          backgroundColor: "#FEF1E7",
          display: "flex",
          alignItems: "center",
          position: "relative",
          paddingLeft: 12,
          minHeight: 56,
          marginBottom: 12,
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 6,
            backgroundColor: color.primary,
          }}
        />

        <Col span={8} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src={icon.DangerTriangle} alt='icon' style={{ width: 22, height: 22 }} />
          <Text fontWeight={700} fontSize={16} color='background4'>
            ชื่อโควตา: &nbsp;
            <Text fontWeight={700} fontSize={16}>
              {quota.quotaName || "-"}
            </Text>
          </Text>
        </Col>

        <Col span={8}>
          <Text fontWeight={700} fontSize={16} color='background4'>
            ประเภทโควตา: &nbsp;
            <Text fontWeight={700} fontSize={16}>
              {MAP_QUOTA_TYPE[quota.quotaType] || "-"}
            </Text>
          </Text>
        </Col>

        <Col span={8}>
          <Text fontWeight={700} fontSize={16} color='background4'>
            ช่วงเวลา: &nbsp;
            <Text fontWeight={700} fontSize={16}>
              {quota.startDate ? dayjs(quota.startDate).format(datePattern) : "-"} -{" "}
              {quota.endDate ? dayjs(quota.endDate).format(datePattern) : "-"}
            </Text>
          </Text>
        </Col>
      </Row>

      <div style={{ padding: "0 22px 22px 22px" }}>
        <TablePagination columns={columns} data={quota.customers} vertical='top' />
      </div>
    </div>
  );
}

export default RenderContent;
